// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"styles_downloadButton__13OKd"};